import { render, staticRenderFns } from "./acao.vue?vue&type=template&id=232e29f1&scoped=true&"
import script from "./acao.vue?vue&type=script&lang=js&"
export * from "./acao.vue?vue&type=script&lang=js&"
import style0 from "./acao.vue?vue&type=style&index=0&id=232e29f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e29f1",
  null
  
)

export default component.exports